/**
 * Sanitize a URL to only allow safe protocols.
 * Returns '#' for any URL that doesn't pass validation.
 */
export function sanitizeUrl(url: string): string {
  try {
    const parsed = new URL(url);
    if (parsed.protocol === 'https:' || parsed.protocol === 'http:') {
      return parsed.href;
    }
    return '#';
  } catch {
    // If it looks like a bare domain, prepend https
    if (/^[a-zA-Z0-9][a-zA-Z0-9-.]+\.[a-zA-Z]{2,}/.test(url)) {
      return sanitizeUrl(`https://${url}`);
    }
    return '#';
  }
}
